/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener("DOMContentLoaded", function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  let spImgList = [
    "https://cdn.shopify.com/s/files/1/0757/3061/6616/files/20250403-p1.png",
    "https://cdn.shopify.com/s/files/1/0757/3061/6616/files/20250403-p2.png",
    "https://cdn.shopify.com/s/files/1/0757/3061/6616/files/20250403-p3.png",
    "https://cdn.shopify.com/s/files/1/0757/3061/6616/files/20250403-p4.png",
    "https://cdn.shopify.com/s/files/1/0757/3061/6616/files/20250403-p5.png",
    "https://cdn.shopify.com/s/files/1/0757/3061/6616/files/20250403-p6.png",
    "https://cdn.shopify.com/s/files/1/0757/3061/6616/files/2_faf66844-2071-4ef1-9112-cacf5065683a.jpg?v=1781245673",
        "https://cdn.shopify.com/s/files/1/0757/3061/6616/files/2_42bb57bb-61d8-4c2a-b9c5-b299387d41c4.jpg?v=1781245673",
            "https://cdn.shopify.com/s/files/1/0757/3061/6616/files/2_66f1e3ac-d0cf-413d-9d5c-589601a821cb.jpg?v=1781245673",
    "https://cdn.shopify.com/s/files/1/0757/3061/6616/files/2_6794fbc8-1a9b-4ee8-89b1-eb89c97b9da9.jpg?v=1781245673",

    "https://cdn.shopify.com/s/files/1/0757/3061/6616/files/2_9c2a1051-96b1-4c41-9f93-2e35023bdcc4.jpg?v=1781245673",

    "https://cdn.shopify.com/s/files/1/0757/3061/6616/files/2_6438788b-4d7f-4b23-b0e7-78a0e9ab8a66.jpg?v=1781245673",

    "https://cdn.shopify.com/s/files/1/0757/3061/6616/files/3_d53266f4-0ab8-4b70-8655-b2d60fbc5221.jpg?v=1781245674",
        "https://cdn.shopify.com/s/files/1/0757/3061/6616/files/3_8e3c3b96-316f-4e6a-b11c-59054a58e1ac.jpg?v=1781245673",
         "https://cdn.shopify.com/s/files/1/0757/3061/6616/files/3_22859d93-5c63-4bde-91f2-3f309461b0d5.jpg?v=1781245673",
    "https://cdn.shopify.com/s/files/1/0757/3061/6616/files/3_9cde49ad-9816-4a9e-a19b-fb1e9bbf8214.jpg?v=1781245673",

    "https://cdn.shopify.com/s/files/1/0757/3061/6616/files/3_72e4a033-006b-4d70-b955-3c6b93815a57.jpg?v=1781245673",
   
    "https://cdn.shopify.com/s/files/1/0757/3061/6616/files/3_e32fcd0f-c3ce-4f86-b39b-2d0a8f4ed735.jpg?v=1781246723",
  ];

  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");
      let scale = document.body.clientWidth / 1080;
      $("#root").css("zoom", scale);

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              $("#root").css("zoom", "normal");
              let scale = document.body.clientWidth / 1080;
              $("#root").css("zoom", scale);
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
      config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        let _topHeight =
          $(".time-part").height() + $(".sp-header-top").height() - 12;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            _topHeight * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log("Android");
    } else if (isIOS) {
      console.log("iOS");
    } else if (isPC) {
      console.log("PC");
    } else {
      $(".sp_system").css("letter-spacing", "-4px");
    }

    // new Swiper(".sp-swiper1", {
    //   direction: "horizontal",
    //   autoplay: true,
    //   autoplay: {
    //     delay: 5000,
    //     disableOnInteraction: false,
    //   },
    //   loop: true,
    // });    
  }

  mainRender();

  let prods = window.product
    function getCur(){
        const color = $('#sp-color .active').attr('data-val')
        const num = $('#sp-number .active').attr('data-val')
        const type = $('#sp-type .active').attr('data-val')
        return prods.filter(item => item.option1 == color && item.option2 == num && item.option3 == type)[0]
    }
    function changePrice(){
      let num = $('#calcNumber').val()
      let price = (getCur().price /100 * num ).toFixed(2)
      let compare = (getCur().compare_at_price /100 * num ).toFixed(2)
      // if (price > 50) {
      //   // $('.product-part .sp-tip').css('display', 'flex')
      //   $('.product-part .btn-free').css('display', 'flex')
      // } else {
      //   // $('.product-part .sp-tip').hide()
      //   $('.product-part .btn-free').hide()
      // }
      $('#sp_price1').html(price)
      $('#sp_price2').html(compare)
      let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
      $(".product-part .price-group .sp-row span").html(`${off_font}`);
    }

  $(".sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
    changePrice()
  });
  $(".sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    changePrice()
  });
  $('.sp-btn-style').click(function(){
    let num = $('#calcNumber').val()
    window.location.href = '/cart/' + getCur().id + ':' + num
  })
  $(function () {
    $(".sp-option").click(function () {
      const isDisabled = $(this).hasClass("disbled");
       if(isDisabled) {
        return;
      }
      $(this).siblings().removeClass("active");
      $(this).addClass("active");
      // style选项

      let colorOptions = $("#sp-color .sp-option.active").index();
      let numberOptions = $("#sp-number .sp-option.active").index();
      let typeOptions = $("#sp-type .sp-option.active").index();
      let _index = numberOptions * 3 + colorOptions + typeOptions * 6;
      // if(colorOptions == 4){
      //   $("#sp-number .sp-option").siblings().removeClass("disbled")
      //   $("#sp-number .sp-option").eq(1).addClass("disbled")
      // }else{
      //   $("#sp-number .sp-option").siblings().removeClass("disbled")
      // }
      // if(colorOptions == 4 && numberOptions == 1){
      //   $("#sp-number .sp-option").siblings().removeClass("active");
      //   $("#sp-number .sp-option").eq(0).addClass("active");
      //    colorOptions = $("#sp-color .sp-option.active").index();
      //  numberOptions = $("#sp-number .sp-option.active").index();
      //  _index = numberOptions * 5 + colorOptions;
      // }
      

      $(".product-part .sp-img-p")[0].src = spImgList[_index];
      if (colorOptions == 0) {
        $(".product-part .sp-name").text("US(110V)");
      } else {
        $(".product-part .sp-name").text("AU(220V)");
      }
      if (numberOptions == 0) {
        $(".product-part .sp-brand").hide();
      } else if (numberOptions == 1) {
        $(".product-part .sp-brand").show();
        $(".product-part .sp-brand .sp-save").text(90);
      } else if (numberOptions == 2) {
        $(".product-part .sp-brand").show();
        $(".product-part .sp-brand .sp-save").text(140);
      }
      changePrice()
    });

    // 购物车加购动效
    $(".cart-btn").click(function () {
      $(this).children("img").addClass("on");
      $(".sp-header-top .sp-cart .num").show();
      setTimeout(function () {
        $(".cart-btn").children("img").removeClass("on");
      }, 500);
      $(".sp-header-top .sp-cart").addClass("on");
      setTimeout(function () {
        $(".sp-header-top .sp-cart").removeClass("on");
      }, 500);
    });
    let initNum = 0;
    $(".product-part .cart-btn").click(function () {
      var data = {
        id: getCur().id,
        quantity: $('#calcNumber').val(),
      };
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
            $("#cardNum").html(result.item_count);
             $("#cardNum").removeClass("sp-gray");
          });
        },
        dataType: "json",
      });
      $("#cardNum").removeClass("sp-gray");
      // handleAddToCart(initNum);

      var img = $(".product-part .sp-img-p");
      // var img = $(".product-part .swiper-slide-active .sp-img");

      var flyer = img[0].cloneNode(true);
      flyer.classList.add("sp_clone");

      $(".product-part").append(flyer);
      $(".sp_clone").css({
        width: img[0].width,
        height: img[0].height,
        position: "fixed",
        top: img[0].offsetTop,
        left: img.offset().left,
        "z-index": "99",
      });

      let finish = $(".sp-cart");
      $(".sp_clone").animate(
        {
          top: finish[0].offsetTop + $('.time-part').height(),
          left: finish[0].offsetLeft + finish.width() / 2,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        500,
        "linear",
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach();
            }
          );
        }
      );
    });
  });
});
